var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bbr-workouts--draft-workouts"},[_c('workouts-list-table',{attrs:{"workouts":_vm.workouts,"loading":_vm.loading,"meta":_vm.listMeta},on:{"goTo":_vm.showDetails,"loadMore":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }